import CourseContentLayoutOperations from "./CourseContentLayoutOperations";

function SeniorCourse(props) {
  return <CourseContentLayoutOperations {...props} totalModules={6} />;
}

export default SeniorCourse;